import type { RouteLocation } from "vue-router";
import { defineNuxtRouteMiddleware } from "#app";
import { $announcementResource, useAnnouncementDataState, isInitialClientLoad } from "#imports";

export default defineNuxtRouteMiddleware( async ( to: RouteLocation ) => {
  // This guard stops API calls from being made twice, one on the server and
  // one on the client, on initial page load.
  if ( isInitialClientLoad() ) {
    return;
  }

  const { getForUrl } = $announcementResource();

  const data = await getForUrl( to.fullPath );

  const state = useAnnouncementDataState();
  if ( data ) {
    state.value = data;
  } else {
    state.value = [];
  }
} );
